import { InjectionToken } from '@angular/core';
import { Observable, Observer } from 'rxjs';

//Estructura del menu de administración
const observableTestMenu = (obs: Observer<any>) => {
    obs.next({
        '1-GestionUsuarios': {
            submenu: {
                '1-AdministracionUsuarios': {
                    submenu: [],
                    title: 'Administración de usuarios',
                    icon: 'fas fa-user',
                    access: false,
                    secure: true,
                    url: 'dashboard/admin-usuarios',
                    rol: ['admin', 'Gestor Ecosistemas'],
                },
            },
            title: 'Gestión de usuarios',
            icon: 'fas fa-users',
            access: true,
            secure: true,
            url: '#',
            rol: ['admin', 'Gestor Ecosistemas'],
        },
        '2-GestionHacedores': {
            submenu: {
                '1-AdminHacedores': {
                    submenu: [],
                    title: 'Administración de perfiles',
                    icon: 'fas fa-user-check',
                    access: false,
                    secure: true,
                    url: 'dashboard/clasificacion-hacedores',
                    rol: ['admin', 'Gestor Hacedores'],
                },
            },
            title: 'Gestión de Hacedores',
            icon: 'fas fa-hand',
            access: true,
            secure: true,
            url: '#',
            rol: ['admin', 'Gestor Hacedores'],
        },
        '3-Reportes': {
            submenu: {
                '1-GenerarReporteUsuarios': {
                    submenu: [],
                    title: 'Directorio de Agentes Culturales, Artísticos y Patrimoniales',
                    icon: 'fas fa-file-alt',
                    access: false,
                    secure: true,
                    url: 'dashboard/reporte-usuarios',
                    rol: ['admin', 'Gestor Ecosistemas'],
                },
                '2-GenerarReporteHacedores': {
                    submenu: [],
                    title: 'Hacedores de oficios artesanales en el espacio público',
                    icon: 'fas fa-file-alt',
                    access: false,
                    secure: true,
                    url: 'dashboard/reporte-hacedores',
                    rol: ['admin','Gestor Hacedores'],
                },
            },
            title: 'Reportes',
            icon: 'fas fa-file-alt',
            access: true,
            secure: true,
            url: '#',
        },
        '4-GestionParametros': {
            submenu: {
                '1-AdminParametros': {
                    submenu: [],
                    title: 'Administración de parámetros',
                    icon: 'fas fa-cogs',
                    access: false,
                    secure: true,
                    url: 'dashboard/gestion-parametros',
                    rol: ['admin'],
                },
            },
            title: 'Gestión de parámetros',
            icon: 'fas fa-cogs',
            access: true,
            secure: true,
            url: '#',
            rol: ['admin'],
        }
    });
    obs.complete();
};

const observableMenu = new Observable<any>(observableTestMenu);

const UrlsMenusServices = {
    fakeService: observableMenu,
    nameService: () => '',
};
export const URLSSERVICES = new InjectionToken('URLSSERVICES', {
    providedIn: 'root',
    factory: () => UrlsMenusServices,
});
